"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchema = exports.MicrofrontendEvents = void 0;
const event1_1 = require("./schemas/event1");
const emptyEvent_1 = require("./schemas/common/emptyEvent");
const onShowGlobalModalSchema_1 = require("./schemas/common/onShowGlobalModalSchema");
const carrierCostUpdateSideEffectScheme_1 = require("./schemas/octopus/payments-widget/carrierCostUpdateSideEffectScheme");
const onDispatchToastNotificationSchema_1 = require("./schemas/common/onDispatchToastNotificationSchema");
const onToastNotificationClickSchema_1 = require("./schemas/common/onToastNotificationClickSchema");
const onDispatchPushNotificationSchema_1 = require("./schemas/common/onDispatchPushNotificationSchema");
const onShowAppBannerSchema_1 = require("./schemas/common/onShowAppBannerSchema");
const onAcceptTermsAndConditionsSchema_1 = require("./schemas/common/onAcceptTermsAndConditionsSchema");
const onTransferStepsActualTimesUpdated_1 = require("./schemas/octopus/execution-stage-widget/onTransferStepsActualTimesUpdated");
const onDetectChangesInExecutionRow_1 = require("./schemas/octopus/execution-stage-widget/onDetectChangesInExecutionRow");
const onCookieConsentSchema_1 = require("./schemas/common/onCookieConsentSchema");
const BidAccepted_1 = require("./schemas/octopus/bidding-mf-page/BidAccepted");
const BidSubmitted_1 = require("./schemas/octopus/bidding-mf-page/BidSubmitted");
const onCreateFacilityProfile_1 = require("./schemas/onCreateFacilityProfile");
const OnMarkTourAsExecutedErrorSchema_1 = require("./schemas/octopus/execution-stage-widget/OnMarkTourAsExecutedErrorSchema");
var MicrofrontendEvents;
(function (MicrofrontendEvents) {
    MicrofrontendEvents["Event1"] = "event1";
    MicrofrontendEvents["PaymentStatusUpdateSideEffect"] = "PaymentStatusUpdateSideEffect";
    MicrofrontendEvents["CarrierCostUpdateSideEffect"] = "CarrierCostUpdateSideEffect";
    MicrofrontendEvents["CarrierCostCloseSideEffect"] = "CarrierCostCloseSideEffect";
    MicrofrontendEvents["onShowGlobalModal"] = "onShowGlobalModal";
    MicrofrontendEvents["onDispatchToastNotification"] = "onDispatchToastNotification";
    MicrofrontendEvents["onToastNotificationClick"] = "onToastNotificationClick";
    MicrofrontendEvents["onDispatchPushNotification"] = "onDispatchPushNotification";
    MicrofrontendEvents["onShowAppBanner"] = "onShowAppBanner";
    MicrofrontendEvents["onCloseAppBanner"] = "onCloseAppBanner";
    MicrofrontendEvents["onAcceptTermsAndConditions"] = "onAcceptTermsAndConditions";
    MicrofrontendEvents["onTransferStepsActualTimesUpdated"] = "onTransferStepsActualTimesUpdated";
    MicrofrontendEvents["onValidateSteps"] = "onValidateSteps";
    MicrofrontendEvents["onSaveOrder"] = "onSaveOrder";
    MicrofrontendEvents["onHandleCloseOrderExecution"] = "onHandleCloseOrderExecution";
    MicrofrontendEvents["onValidateStepsAndCompulsoryTimestamps"] = "onValidateStepsAndCompulsoryTimestamps";
    MicrofrontendEvents["onCloseOrderExecution"] = "onCloseOrderExecution";
    MicrofrontendEvents["onStartSavingProgress"] = "onStartSavingProgress";
    MicrofrontendEvents["onStopSavingProgress"] = "onStopSavingProgress";
    MicrofrontendEvents["onStopClosingProgress"] = "onStopClosingProgress";
    MicrofrontendEvents["onRefreshOneViewGrid"] = "onRefreshOneViewGrid";
    MicrofrontendEvents["onDetectChangesInExecutionRow"] = "onDetectChangesInExecutionRow";
    MicrofrontendEvents["onLoadingComplete"] = "onLoadingComplete";
    MicrofrontendEvents["onPodApprovedOrRejected"] = "onPodApprovedOrRejected";
    MicrofrontendEvents["onCookieConsent"] = "onCookieConsent";
    MicrofrontendEvents["onUpdateFacilityPlan"] = "onUpdateFacilityPlan";
    MicrofrontendEvents["BidAccepted"] = "BidAccepted";
    MicrofrontendEvents["onFacilityPlanUnsavedChanges"] = "onFacilityPlanUnsavedChanges";
    MicrofrontendEvents["BidSubmitted"] = "BidSubmitted";
    MicrofrontendEvents["onCreateFacilityProfile"] = "onCreateFacilityProfile";
    MicrofrontendEvents["onPaymentStarted"] = "onPaymentStarted";
    MicrofrontendEvents["onFileClaim"] = "onFileClaim";
    MicrofrontendEvents["onMarkTourAsExecutedError"] = "onMarkTourAsExecutedError";
    MicrofrontendEvents["onRefreshOrderLogs"] = "onRefreshOrderLogs";
    MicrofrontendEvents["showCreateShipmentFlow"] = "showCreateShipmentFlow";
})(MicrofrontendEvents = exports.MicrofrontendEvents || (exports.MicrofrontendEvents = {}));
const schemas = {
    [MicrofrontendEvents.Event1]: event1_1.default,
    [MicrofrontendEvents.PaymentStatusUpdateSideEffect]: emptyEvent_1.default,
    [MicrofrontendEvents.CarrierCostUpdateSideEffect]: carrierCostUpdateSideEffectScheme_1.default,
    [MicrofrontendEvents.CarrierCostCloseSideEffect]: emptyEvent_1.default,
    [MicrofrontendEvents.onShowGlobalModal]: onShowGlobalModalSchema_1.default,
    [MicrofrontendEvents.onDispatchToastNotification]: onDispatchToastNotificationSchema_1.default,
    [MicrofrontendEvents.onToastNotificationClick]: onToastNotificationClickSchema_1.default,
    [MicrofrontendEvents.onDispatchPushNotification]: onDispatchPushNotificationSchema_1.default,
    [MicrofrontendEvents.onShowAppBanner]: onShowAppBannerSchema_1.default,
    [MicrofrontendEvents.onCloseAppBanner]: emptyEvent_1.default,
    [MicrofrontendEvents.onAcceptTermsAndConditions]: onAcceptTermsAndConditionsSchema_1.default,
    [MicrofrontendEvents.onTransferStepsActualTimesUpdated]: onTransferStepsActualTimesUpdated_1.default,
    [MicrofrontendEvents.onValidateSteps]: emptyEvent_1.default,
    [MicrofrontendEvents.onSaveOrder]: emptyEvent_1.default,
    [MicrofrontendEvents.onHandleCloseOrderExecution]: emptyEvent_1.default,
    [MicrofrontendEvents.onValidateStepsAndCompulsoryTimestamps]: emptyEvent_1.default,
    [MicrofrontendEvents.onCloseOrderExecution]: emptyEvent_1.default,
    [MicrofrontendEvents.onStartSavingProgress]: emptyEvent_1.default,
    [MicrofrontendEvents.onStopSavingProgress]: emptyEvent_1.default,
    [MicrofrontendEvents.onStopClosingProgress]: emptyEvent_1.default,
    [MicrofrontendEvents.onRefreshOneViewGrid]: emptyEvent_1.default,
    [MicrofrontendEvents.onDetectChangesInExecutionRow]: onDetectChangesInExecutionRow_1.default,
    [MicrofrontendEvents.onLoadingComplete]: emptyEvent_1.default,
    [MicrofrontendEvents.onPodApprovedOrRejected]: emptyEvent_1.default,
    [MicrofrontendEvents.onCookieConsent]: onCookieConsentSchema_1.default,
    [MicrofrontendEvents.onUpdateFacilityPlan]: emptyEvent_1.default,
    [MicrofrontendEvents.BidAccepted]: BidAccepted_1.default,
    [MicrofrontendEvents.onFacilityPlanUnsavedChanges]: emptyEvent_1.default,
    [MicrofrontendEvents.BidSubmitted]: BidSubmitted_1.default,
    [MicrofrontendEvents.onCreateFacilityProfile]: onCreateFacilityProfile_1.default,
    [MicrofrontendEvents.onPaymentStarted]: emptyEvent_1.default,
    [MicrofrontendEvents.onFileClaim]: emptyEvent_1.default,
    [MicrofrontendEvents.onMarkTourAsExecutedError]: OnMarkTourAsExecutedErrorSchema_1.default,
    [MicrofrontendEvents.onRefreshOrderLogs]: emptyEvent_1.default,
    [MicrofrontendEvents.showCreateShipmentFlow]: emptyEvent_1.default
};
function getSchema(eventName) {
    if (!schemas[eventName]) {
        throw new Error(`No schema for ${eventName}`);
    }
    return schemas[eventName];
}
exports.getSchema = getSchema;
